/** @jsxImportSource @emotion/react */

import FilterableConfigList from "./FilterableConfigList";
import { yesOrNoRadio } from "./util";

const defaultField = {
    field: {
        label: "Packing",
        type: "packing",
        mandatory: false,
        meta_conditions: []
    },
    display_filter: {
        fruit_types: [],
        exclude_fruit_types: [],
        layer_types: [],
        meta_conditions: []
    }
};
export default function RequiredImageConfigForm({ name, title, fields, description, setArray, useDisplayFilter = ["fruit_types", "exclude_fruit_types", "meta_conditions"] }) {
    const getFieldTitle = (object) => (
        <span>
            {object.label}
            {object.mandatory && <span className="text-danger ms-2">*</span>}
        </span>
    );
    const getFieldForm = (object, setObject) => [
        {
            label: "Label",
            type: "text",
            name: "label",
            onchange_callback: ({ field, value }) => {
                setObject({ ...object, [field]: value, type: value.trim().replaceAll(" ", "_").toLowerCase() });
            },
        },
        {
            label: "Type",
            type: "text",
            name: "type",
        },
        {
            label: "Mandatory",
            name: "mandatory",
            description: "If checked, at least one image of this type must be uploaded before proceeding",
            ...yesOrNoRadio
        },


    ];
    return <FilterableConfigList
        name={name}
        title={title}
        description={description}
        fields={fields}
        setArray={setArray}
        defaultField={defaultField}
        getFieldForm={getFieldForm}
        getFieldTitle={getFieldTitle}
        useDisplayFilter={useDisplayFilter}
    />;

}


